/**
 * SignUp Page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Platform, NavController, LoadingController, AlertController, ToastController, NavParams, ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PouchService } from '../services/pouch-service';
import { Subject } from 'rxjs/Subject';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'page-signup',
  templateUrl: 'signup.html',
  styleUrls: ['signup.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SignupPage {
  user = {
    id: '',
    rev: '',
    name: '',
    fullname: '',
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    phonenumber: this.db.userinfo.country_calling_code || '',
    country: this.db.userinfo.country || '',
    online: true,
    type: 'register',
    product: this.db.appinfo.base_product,
    version: '1.0.0',
  };
  usernamechange: Subject<string> = new Subject<string>();
  emailchange: Subject<string> = new Subject<string>();
  phonenumberchange: Subject<string> = new Subject<string>();
  error = '';
  registerForm: FormGroup = null;
  private baseUrl = 'https://sarutech.com/api/app/rest';
  submitAttempt = false;
  userexist = false;
  emailexist = false;
  userchecking = false;
  emailchecking = false;
  email_verified = false;
  email_pending = false;
  phonenumberchecking = false;
  phonenumber_verified = false;
  phonenumber_pending = false;
  last: any = '';
  ios = false;
  add = false;

  constructor(public modalCtrl: ModalController, private route: ActivatedRoute, public loadingCtrl: LoadingController, private titleService: Title, public toastController: ToastController, public alertCtrl: AlertController, public formBuilder: FormBuilder, private platform: Platform, public nav: NavController, public http: HttpClient, public db: PouchService, private router: Router) {
    if (this.platform.is('ios')) {
      this.ios = true;
    }
    this.titleService.setTitle(`Create a Database - ${this.db.appinfo.title}`);
    localStorage.removeItem(this.db.appinfo.base_product); // remove this to avoid errors
    this.db.appinfo.product = this.db.appinfo.base_product; // make sure this references base product
    this.registerForm = formBuilder.group({
      name: ['', Validators.compose([Validators.required])],
      username: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9_]+$'), Validators.minLength(4), Validators.maxLength(16)])], // username can only contain letters, numbers and underscores
      password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')])],
      phonenumber: ['', Validators.compose([Validators.required, Validators.pattern('^\\+[1-9]{1}[0-9]{3,14}$')])],
      country: ['', Validators.compose([Validators.required])],
    });

    this.route.queryParams.subscribe(async (params) => {
      if (params.email) {
        this.db.loading = await this.loadingCtrl.create({
          message: `${this.db.rename('Please wait')}...`,
        });
        await this.db.loading.present();
        this.http.get(`https://sarutech.com/api/app/getCustomer?email=${params.email}`).subscribe((customer: any) => {
          let credentials = {
            user_id: customer.data.username,
            password: customer.data._password,
            online: false,
            skip_setup: false,
          };
          let plan = 'free';
          if (customer.data.plans) {
            plan = customer.data.plans[customer.data.plans.length - 1];
          }
          this.user.username = customer.data.username;
          this.user.password = customer.data._password;
          this.user.confirmPassword = customer.data._password;
          this.user.fullname = customer.data.fullname;
          this.user.name = customer.data.fullname;
          this.user.email = customer.data.email;
          this.user.phonenumber = customer.data.phonenumber;
          this.user.country = customer.data.country;
          let period = 12 * (parseFloat(params.multiplier) || 1);
          period = parseFloat(period.toFixed(0));
          this.initSettings(credentials, plan, period, 'months');
        });
      } else {
        if (this.db.gsetting && this.db.gsetting.username) {
          this.add = true;
        }
        this.usernamechange
          .debounceTime(4000) // wait 1 sec after the last event before emitting last event
          .subscribe((model) => {
            if (this.last != model && this.user.username != '') {
              this.userexist = false;
              this.userchecking = true;
              this.http.get('https://sarutech.com/couchdblogin/auth/validate-username/' + this.user.username).subscribe(
                (data) => {
                  this.userchecking = false;
                },
                (err) => {
                  if (err?.status == 0 || err?.error?.error == 'Username already in use') {
                    if (model.length > 12) {
                      model = model.slice(0, 12);
                    }
                    this.last = this.user.username = model + Math.floor(Math.random() * 1000);
                  }
                  this.userchecking = false;
                }
              );
            }
          });

        this.emailchange
          .debounceTime(4000) // wait 1 sec after the last event before emitting last event
          .subscribe((model) => {
            //also check if it contains value after the @ and a dot
            if (this.user.email != undefined && this.db.online && this.user.email != '' && this.user.email.includes('@') && this.user.email.includes('.') && this.user.email.length > 5 && this.user.email.indexOf('@') < this.user.email.lastIndexOf('.') && this.user.email.lastIndexOf('.') < this.user.email.length - 1 && this.user.email.length - this.user.email.lastIndexOf('.') - 1 <= 3) {
              /* this.userexist = false;
              this.emailchecking = true;
              this.validateEmail(); */
              this.email_verified = true;
              this.email_pending = false;
            }
          });

        this.phonenumberchange
          .debounceTime(4000) // wait 1 sec after the last event before emitting last event
          .subscribe((model) => {
            if (this.user.phonenumber != undefined && this.db.online && this.user.phonenumber != '' && this.user.phonenumber != this.db.userinfo.country_calling_code) {
              // remove spaces from phone number
              this.user.phonenumber = this.user.phonenumber.replace(/\s/g, '');
              /* this.phonenumberchecking = true;
              this.validatePhone(); */
              this.phonenumber_verified = true;
              this.phonenumber_pending = false;
            }
          });
      }
    });
  }

  async validateEmail() {
    //generate 4 digit verification code
    let verification = Math.floor(1000 + Math.random() * 9000);
    // email validation code
    this.db.sendEmailToUser(this.user.email, `${this.db.rename('Verification Code from')} ${this.db.appinfo.title}`, `${this.db.rename('Your Verification Code is')}: ${verification}`);
    let alert = await this.alertCtrl.create({
      header: this.db.rename('Enter Verification Code'),
      message: `${this.db.rename(`Enter verification code sent to your email`)}: ${this.user.email} ${this.db.rename(`Please check your spam folder if you have not received it after a few minutes`)}.`,
      inputs: [
        {
          name: 'code',
          placeholder: this.db.rename('Verification Code'),
          value: '',
        },
      ],
      buttons: [
        {
          text: this.db.rename('Cancel'),
          handler: (data) => {
            this.email_verified = false;
            this.email_pending = true;
            this.emailchecking = false;
          },
        },
        {
          text: this.db.rename('Verify'),
          handler: (data) => {
            this.email_verified = true;
            this.emailchecking = false;
            this.email_pending = false;
            this.presentToast(this.db.rename('Email Verified'), 'toast-success');
          },
        },
      ],
    });
    alert.present();
  }

  async validatePhone() {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    //check if number has any country code and is in the right format
    if (this.user.phonenumber.includes('+') && this.user.phonenumber.length > 9 && this.user.phonenumber.length < 16) {
      // send zapier message
      let alert = await this.alertCtrl.create({
        header: this.db.rename('Send us a verification code'),
        message: `<div class="verifywhatsapp">${this.db.rename(`Please send`)} <i>${this.db.appinfo.base_product}</i> ${this.db.rename('to')} <a href="https://api.whatsapp.com/send/?phone=447823606537" target="_blank"><img src="assets/img/whatsapp.png" /> +447823606537</a> <br/> ${this.db.rename('from your WhatsApp number')}: ${this.user.phonenumber} ${this.db.rename('and click verify')}`,
        buttons: [
          {
            text: this.db.rename('Cancel'),
            handler: (data) => {
              this.phonenumber_verified = false;
              this.phonenumber_pending = true;
              this.phonenumberchecking = false;
            },
          },
          {
            text: this.db.rename('Verify'),
            handler: () => {
              this.phonenumber_verified = true;
              this.phonenumberchecking = false;
              this.phonenumber_pending = false;
              this.presentToast(this.db.rename('Phone Number Verified'), 'toast-success');
              this.http.post('https://sarutech.com/api/app/whatsappZapier', { product: this.db.appinfo.base_product, message: `${this.user.username} is trying to create an account with WhatsApp number ${this.user.phonenumber} and email address: ${this.user.email} from ${this.db.userinfo.country}` }, { headers: headers });
            },
          },
        ],
      });
      alert.present();
    } else {
      this.phonenumber_verified = false;
      this.phonenumberchecking = false;
      if (this.user.phonenumber == '') {
        this.presentToast(this.db.rename('Please enter your Business Name'), 'toast-danger');
      } else if (this.user.phonenumber == '') {
        this.presentToast(this.db.rename('Please enter a valid WhatsApp Number'), 'toast-danger');
      } else if (!this.user.phonenumber.includes('+') || this.user.phonenumber.length < 10 || this.user.phonenumber.length > 15) {
        this.presentToast(this.db.rename('Phone number must include country code and be between 10 and 15 digits'), 'toast-danger');
      } else {
        this.presentToast(this.db.rename('Please enter your Business Name and a valid WhatsApp Number'), 'toast-danger');
      }
    }
  }

  async presentToast(message, type = 'toast-success') {
    const toast = await this.toastController.create({
      message: message,
      duration: 4000,
      cssClass: type,
    });
    toast.present();
  }

  onUsernameChange(query: string) {
    if (query != undefined) {
      this.usernamechange.next(query);
    }
  }
  onEmailChange(query: string) {
    this.emailchange.next(query);
  }

  onPhonenumberChange(query: string) {
    this.phonenumberchange.next(query);
  }

  ngOnInit() {
    this.platform.ready().then(() => {
      this.onlineCheck();
    });
  }

  onlineCheck() {
    this.http.get('https://sarutech.com/couchdblogin/auth/validate-username/xs2da2432252sda').subscribe(
      (data) => {
        this.db.online = true;
        console.log(this.db.online);
      },
      (err) => {
        this.db.online = false;
        console.log(this.db.online);
      }
    );
  }

  async register() {
    this.db.loading = await this.loadingCtrl.create({
      message: `${this.db.rename('Please wait')}...`,
    });
    if (this.registerForm.valid && (this.email_verified || this.email_pending) && (this.phonenumber_verified || this.phonenumber_pending)) {
      this.user.username = this.user.username.toLowerCase();
      this.user.confirmPassword = this.user.password;
      this.user.fullname = this.user.name;
      this.submitAttempt = true;
      await this.db.loading.present();
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      // New Registeration
      let credentials = {
        user_id: this.user.username,
        password: this.user.password,
        online: false,
        skip_setup: false,
      };
      this.http.post('https://sarutech.com/api/app/rest', JSON.stringify(this.user)).subscribe(
        (res) => {
          this.initSettings(credentials);
        },
        (err) => {
          this.initSettings(credentials);
        }
      );
    } else if (!this.email_verified) {
      this.presentToast(this.db.rename('Please enter and verify your email (Requires Internet Connection)'), 'toast-danger');
    } else if (!this.phonenumber_verified) {
      this.presentToast(this.db.rename('Please enter and verify your WhatsApp number (Requires Internet Connection)'), 'toast-danger');
    } else {
      this.presentToast(this.db.rename('Please ensure all field are filled with valid information'), 'toast-danger');
    }
  }

  initSettings(credentials, plan = 'free', period = 7, unit = 'days') {
    if (this.add) {
      this.db.resetSession();
    }
    this.db.initDB(credentials, true).then((res) => {
      this.db.newSystemSetting(credentials, this.user).then((gsetting) => {
        this.db.gsetting = gsetting;
        this.db.appinfo.settings[0] = `setting_2_${this.db.gsetting.id}`;
        this.db.extendLicense(plan).then((res) => {
          this.db.setExpire(period, unit).then(async (res2) => {
            if (this.db.loading) {
              await this.db.loading.dismiss();
            }
            this.db.loading = null;
            console.log('finished settings');
            if (this.add) {
              window.location.reload();
            } else {
              this.router.navigateByUrl('/LoginUserPage', {
                state: { start: true },
              }); //go login user
            }
          });
        });
      });
    });
  }

  account() {
    this.nav.pop();
    this.router.navigateByUrl('/AccountPage');
  }

  dismiss() {
    this.emailexist = !this.emailexist;
    this.user.email = '';
  }

  back() {
    this.nav.pop();
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  help(page) {
    window.open('https://sarutech.com/documentation/' + page);
  }
}
